import { lazyLoad, LazyLoadedComponent, PlatformRoute } from '~/libs/core'
import { AppSubdomain, EnvironmentConfig, ToolTitle } from '~/config'

const EngagementsApp: LazyLoadedComponent = lazyLoad(() => import('./EngagementsApp'))

const EngagementListPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/engagement-list'),
    'EngagementListPage',
)
const EngagementDetailPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/engagement-detail'),
    'EngagementDetailPage',
)
const AnonymousFeedbackPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/anonymous-feedback'),
    'AnonymousFeedbackPage',
)
const LeadIntakePage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/lead-intake'),
    'LeadIntakePage',
)
const WiproDirectLeadIntakePage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/lead-intake'),
    'WiproDirectLeadIntakePage',
)
const ApplicationFormPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/application-form'),
    'ApplicationFormPage',
)
const MyApplicationsPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/my-applications'),
    'MyApplicationsPage',
)
const MyAssignmentsPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/my-assignments'),
    'MyAssignmentsPage',
)
const TimesheetsPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/timesheets'),
    'TimesheetsPage',
)
const TimesheetEngagementsPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/timesheets'),
    'TimesheetEngagementsPage',
)

export const rootRoute: string = (
    EnvironmentConfig.SUBDOMAIN === AppSubdomain.engagements ? '' : `/${AppSubdomain.engagements}`
)

export const toolTitle: string = ToolTitle.engagements
export const absoluteRootRoute: string = `${window.location.origin}${rootRoute}`

export const engagementsRoutes: ReadonlyArray<PlatformRoute> = [
    {
        authRequired: false,
        children: [
            {
                children: [],
                element: <EngagementListPage />,
                id: 'Engagement List',
                route: '',
            },
            {
                children: [],
                element: <LeadIntakePage />,
                id: 'Engagement Lead Intake',
                route: 'intake',
            },
            {
                children: [],
                element: <WiproDirectLeadIntakePage />,
                id: 'Wipro Direct Engagement Lead Intake',
                route: 'intake/wipro-direct',
            },
            {
                children: [],
                element: <AnonymousFeedbackPage />,
                id: 'Anonymous Feedback',
                route: 'feedback/anonymous/:secretToken',
            },
            {
                children: [],
                element: <EngagementDetailPage />,
                id: 'Engagement Detail',
                route: ':nanoId',
            },
            {
                authRequired: true,
                children: [],
                element: <ApplicationFormPage />,
                id: 'Application Form',
                route: ':nanoId/apply',
            },
            {
                authRequired: true,
                children: [],
                element: <MyApplicationsPage />,
                id: 'My Applications',
                route: 'my-applications',
            },
            {
                authRequired: true,
                children: [],
                element: <MyAssignmentsPage />,
                id: 'My Assignments',
                route: 'assignments',
            },
            {
                authRequired: true,
                children: [],
                element: <TimesheetEngagementsPage />,
                id: 'Timesheets',
                route: 'timesheets',
            },
            {
                authRequired: true,
                children: [],
                element: <TimesheetsPage />,
                id: 'Timesheet',
                route: ':engagementId/timesheets/:assignmentId',
            },
        ],
        domain: AppSubdomain.engagements,
        element: <EngagementsApp />,
        id: toolTitle,
        route: rootRoute,
        title: toolTitle,
    },
]
